export default __webpack_public_path__ + "images/f46cd3e526949ff315cd07a281a73b11-Doctor.png";